import React from 'react';
import { ColumnSelectOption } from 'lib/components/ColumnSelect';
import { OrganizationMultiSelectPopover } from './OrganizationMultiSelectPopover';

type OrganizationSelectorProps = {
  value: string[];
  options: ColumnSelectOption<string>[] | null;
  onChange: (value: string[]) => void;
};

export function OrganizationSelector({
  value,
  options,
  onChange
}: OrganizationSelectorProps) {
  return (
    <OrganizationMultiSelectPopover
      value={value}
      onChange={onChange}
      options={options || []}
    />
  );
}
